/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");
require("select2");
require("moment");

import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";

Sentry.init({
  dsn: "https://5b28afd5bfb15d22df7776c1399a95fe@o4508331645009920.ingest.de.sentry.io/4509033414983760",
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
});

// Setta i tag dal backend
if (window.SENTRY_TAGS) {
  Sentry.setTag("tenant.uuid", window.SENTRY_TAGS.tenant_uuid);
  Sentry.setTag("tenant.url", window.SENTRY_TAGS.tenant_url);
}


const Chart = require("chart.js");

import Vue from "vue";
import Vuetable from "vuetable-2";
window.Vue = Vue;
window.Vuetable = Vuetable;

import _ from "lodash";

Vue.prototype.__ = (str) => _.get(window.i18n, str);

import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import VuetablePaginationMixin from "vuetable-2/src/components/VuetablePaginationMixin";

Vue.use(Vuetable);
Vue.component("vuetable-pagination-info", VuetablePaginationInfo);

import axios from "axios";

import VueSweetalert2 from "vue-sweetalert2";
// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);

import VueToast from "vue-toast-notification";
// Import any of available themes
import "vue-toast-notification/dist/theme-default.css";
Vue.use(VueToast);

import Vuesax from "vuesax";
import "vuesax/dist/vuesax.css";
Vue.use(Vuesax, {
  // options here
});

import momentVue from "vue-moment";
Vue.use(momentVue);

import VueCarousel from "vue-carousel";
Vue.use(VueCarousel);
Vue.component(
  "dashboard-carousel",
  require("./components/Carousel.vue").default,
);

Vue.component("vuetable-detail-row-sub-table", require("./components/vueTable/DetailRowSubTable.vue").default);
Vue.component("vuetable-detail-row-sub-cards", require("./components/vueTable/DetailRowSubCards.vue").default);

import VueCurrencyInput from "vue-currency-input";
Vue.use(VueCurrencyInput);

import { Tabs, Tab } from "vue-tabs-component";
Vue.component("tabs", Tabs);
Vue.component("tab", Tab);

import VueGoogleCharts from "vue-google-charts";
Vue.use(VueGoogleCharts);

import Multiselect from "vue-multiselect";

import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

Vue.component("multiselect", Multiselect);
Vue.component(
  "multiselect-base",
  require("./components/MultiSelectBase.vue").default,
);
Vue.component(
  "multiselect-categories",
  require("./components/Categories.vue").default,
);

import VueCropper from "vue-cropperjs";
Vue.use(VueCropper);
import "cropperjs/dist/cropper.css";

Vue.component(
  "image-upload-resize",
  require("./components/ImageResize.vue").default,
);

Vue.component(
  "multiselect-tags",
  require("./components/MultiselectTags.vue").default,
);

Vue.component(
  "ck-editor",
  require("./components/ckeditor/CkEditor.vue").default,
);

//components

Vue.component(
  "input-text-and-tags",
  require("./components/InputTextAndTags").default,
);
Vue.component(
  "input-file-drag-drop",
  require("./components/InputFileDragDrop").default,
);
Vue.component("input-link", require("./components/InputFileLink").default);
Vue.component("move-file", require("./components/MoveFile").default);
Vue.component(
  "manage-file-folders",
  require("./components/ManageFileFolders").default,
);

Vue.component(
  "hrt-jobs-frequency-selecter",
  require("./components/hrtJobs/HrtJobsFrequencySelecter").default,
);
Vue.component(
  "hrt-multi-select",
  require("./components/common/hrtMultiSelect").default,
);

//input currency
Vue.component(
  "input-number-currency",
  require("./components/InputNumberCurrency.vue").default,
);

// Conditional selects
Vue.component(
  "select-person-and-role",
  require("./components/people/selectPersonAndRole").default,
);

Vue.component(
  "select-responsible-and-role",
  require("./components/people/selectResponsibleAndRole").default,
);

Vue.component(
  "select-module-and-widget",
  require("./components/hr/selectModuleAndWidget").default,
);

Vue.component(
  "wapp-template-message",
  require("./components/WappTemplateMessage").default,
);

//responsible get roles
Vue.component(
  "get-roles-by-responsible",
  require("./components/people/responsibleRoles").default,
);
Vue.component(
  "dropdown-to-go",
  require("./components/DropdownToGo.vue").default,
);
Vue.component(
  "dropdown-to-go-collaborators",
  require("./components/DropdownToGoCollaborators.vue").default,
);
Vue.component(
  "dropdown-to-go-reward",
  require("./components/DropdownToGoReward.vue").default,
);
Vue.component(
  "little-preview-file",
  require("./components/LittlePreviewFile.vue").default,
);

//Vuetable
Vue.component(
  "vuetable-component",
  require("./components/VuetableComponent.vue").default,
);
Vue.component(
  "vuetable-component-evalutation",
  require("./components/VuetableComponentEvaluation.vue").default,
);
Vue.component(
  "vuetable-component-actions",
  require("./components/vueTable/Actions.vue").default,
);
Vue.component(
  "vuetable-pagination",
  require("./components/vueTable/Pagination").default,
); //VuetablePagination);
Vue.component(
  "filter-bar",
  require("./components/vueTable/FilterBar.vue").default,
);
Vue.component(
  "filter-barevalutation",
  require("./components/vueTable/FilterBarEvalutation.vue").default,
);
Vue.component(
  "approve-person-kpi",
  require("./components/vueTable/kpi/ApproveRejectPersonKpi.vue").default,
);

Vue.component(
  "advanced-filter-selector",
  require("./components/AdvanceFilterSelector.vue").default,
);
//Permissions
Vue.component(
  "permission-preset",
  require("./components/PermissionPreset.vue").default,
);

Vue.component(
  "permission-folder-person",
  require("./components/PermissionFolderPerson.vue").default,
);
Vue.component(
  "permission-folder-person-visibility",
  require("./components/PermissionFolderPersonVisibility.vue").default,
);

Vue.component(
  "applicant-new-candidate-roles",
  require("./components/recruiting/ApplicantCandidateRoles.vue").default,
);
//VueTable Hiring/Rejecting Applicant
Vue.component(
  "vuetable-recruitment-applicants-hire-reject",
  require("./components/vueTable/recruiting/HireRejectAction.vue").default,
);
Vue.component(
  "applicant-store-hiring-info",
  require("./components/vueTable/recruiting/HireApplicantStoreHiringInfo.vue")
    .default,
);
Vue.component(
  "applicant-manage-roles",
  require("./components/recruiting/ApplicantRoles.vue").default,
);
Vue.component(
  "applicant-input-file-drag-drop",
  require("./components/recruiting/ApplicantInputFileDragDrop.vue").default,
);

//Vuetable Deliberation/Approvation Roles Uo
Vue.component(
  "vuetable-deliberation-validation-roles",
  require("./components/vueTable/roles/DeliberationApprovationRoles.vue")
    .default,
);

//Vue.component('language-header', require('./components/header/LanguageHeader.vue').default);
Vue.component(
  "toggle-menu",
  require("./components/header/ToggleMenu.vue").default,
);
Vue.component(
  "notifications-header",
  require("./components/header/NotificationsHeader.vue").default,
);
Vue.component(
  "profile-header",
  require("./components/header/ProfileHeader.vue").default,
);
Vue.component(
  "language-header",
  require("./components/header/LanguageHeader.vue").default,
);
Vue.component("example-component", require("./components/Example.vue").default);
Vue.component(
  "vue-sidebar",
  require("./components/vueSax/sideBar.vue").default,
);
Vue.component("vue-popup", require("./components/vueSax/popup.vue").default);
Vue.component(
  "popup-note",
  require("./components/vueSax/popup-note.vue").default,
);
Vue.component(
  "popup-documents",
  require("./components/vueSax/popup-documents.vue").default,
);
Vue.component(
  "popup-new-task",
  require("./components/vueSax/popup-new-task.vue").default,
);
Vue.component(
  "popup-mono-text",
  require("./components/vueSax/popup-mono-text.vue").default,
);

Vue.component("vue-datepicker", require("./components/DatePicker.vue").default);
Vue.component("copy-url", require("./components/CopyUrl.vue").default);

//People
Vue.component(
  "people-handle-absence",
  require("./components/people/HandleAbsence.vue").default,
);

Vue.component(
  "personal-skills",
  require("./components/people/PersonalSkills.vue").default,
);
Vue.component(
  "responsible-person-list",
  require("./components/people/ResponsiblePersonList.vue").default,
);
Vue.component(
  "project-handle-person",
  require("./components/ProjectHandlePerson.vue").default,
);
Vue.component(
  "printer-selection",
  require("./components/PrinterSelection.vue").default,
);
Vue.component(
  "person_group_selector",
  require("./components/PersonGroupSelector.vue").default,
);
Vue.component(
  "pay-item-handle-person",
  require("./components/PayItemHandlePerson.vue").default,
);
Vue.component(
  "contractual-item-handle-person",
  require("./components/ContractualItemHandlePerson.vue").default,
);
Vue.component(
  "profile-person-skill",
  require("./components/people/ProfileSkillApprove").default,
);
Vue.component(
  "person-skill-simulation",
  require("./components/people/ProfileSkillSimulation").default,
);
Vue.component(
  "multiple-lookup",
  require("./components/MultipleLookup").default,
);
Vue.component(
  "person-organizational-units-panel",
  require("./components/people/OrganizationalUnitPerson").default,
);

//EAVs

Vue.component(
  "eavs-field-option",
  require("./components/eavs/FieldOption.vue").default,
);

//Learning
Vue.component(
  "training-request-form",
  require("./components/learning/trainingRequest/TrainingRequestForm").default,
);
Vue.component(
  "satisfaction-survey-settings",
  require("./components/learning/satisfactionSurvey/SatisfactionSurveySettings")
    .default,
);
Vue.component(
  "satisfaction-survey-question-settings",
  require("./components/learning/satisfactionSurvey/SatisfactionQuestionSurveySettings")
    .default,
);

Vue.component(
  "satisfaction-survey-summary",
  require("./components/learning/satisfactionSurvey/SummarySatisfactionSurvey")
    .default,
);
Vue.component(
  "satisfaction-survey-group",
  require("./components/learning/satisfactionSurvey/SatisfactionSurveyGroup")
    .default,
);

//Charts

Vue.component("line-chart", require("./components/charts/Line.vue").default);
Vue.component("pie-chart", require("./components/charts/Pie.vue").default);
Vue.component(
  "doughnut-chart",
  require("./components/charts/Doughnut.vue").default,
);
Vue.component("bar-chart", require("./components/charts/Bar.vue").default);
Vue.component(
  "horiz-bar-chart",
  require("./components/charts/HorizontalBar.vue").default,
);
Vue.component(
  "stacked-bar-chart",
  require("./components/charts/StackedBar.vue").default,
);
Vue.component(
  "stacked-bar-chart-toogle",
  require("./components/charts/StackedBarToogle.vue").default,
);
Vue.component(
  "bar-line-chart",
  require("./components/charts/BarLine.vue").default,
);
Vue.component(
  "bar-line-chart-toogle",
  require("./components/charts/BarLineToogle.vue").default,
);
Vue.component(
  "first-chart",
  require("./components/charts/FirstChart.vue").default,
);
Vue.component(
  "scatter-chart",
  require("./components/charts/Scatter.vue").default,
);
Vue.component("plain-chart", require("./components/charts/Plain.vue").default);
Vue.component(
  "horizontal-bar-chart",
  require("./components/charts/HorizontalBarLine.vue").default,
);
Vue.component("radar-chart", require("./components/charts/Radar.vue").default);
Vue.component(
  "skills-for-people",
  require("./components/charts/SkillsForPeople.vue").default,
);

//Filters of Widgets

Vue.component(
  "filters-behaviors",
  require("./components/charts/filters/BehaviorsFilters.vue").default,
);
Vue.component(
  "filters-summaryEvalutaion",
  require("./components/charts/filters/SummaryEvalutationFilter.vue").default,
);
Vue.component(
  "filters-skills-for-people",
  require("./components/charts/filters/SkillsForPeopleFilters.vue").default,
);
Vue.component(
  "filters-pay-items-with",
  require("./components/charts/filters/PayItemsWithFilters.vue").default,
);

Vue.component(
  "documents-table-sharing",
  require("./components/DocumentsTableSharing").default,
);
Vue.component(
  "documents-table",
  require("./components/DocumentsTable").default,
);
Vue.component(
  "documents-people-sender",
  require("./components/DocumentPeopleSender").default,
);
Vue.component(
  "documents-people-share-from-folder",
  require("./components/DocumentPeopleShareFormFolder").default,
);

Vue.component(
  "parents-to-children",
  require("./components/ParentToChildren").default,
);
Vue.component(
  "parents-to-children-to-grandson",
  require("./components/ParentToChildrenToGrandson").default,
);

Vue.component("org-chart", require("./components/OrgChart.vue").default);
Vue.component("mind-map", require("./components/MindMap.vue").default);

Vue.component(
  "add-massive-person-skills",
  require("./components/people/AddMassivePersonSkill.vue").default,
);
Vue.component(
  "check-person-got-roles",
  require("./components/people/CheckPersonGotRoles").default,
);
Vue.component(
  "history-model",
  require("./components/HistoryModel.vue").default,
);
Vue.component(
  "custom-owner-form-field",
  require("./components/CustomOwnerFormField.vue").default,
);

//Recruiting Charts create form with bothType of Person
Vue.component(
  "recruiting-chart-create-status-person",
  require("./components/recruiting/RecruitingChartCreateStatusPerson.vue")
    .default,
);

Vue.component(
  "skills-person",
  require("./components/recruiting/SkillsPerson.vue").default,
);
Vue.component(
  "skills-applicant",
  require("./components/recruiting/SkillsApplicant.vue").default,
);
Vue.component(
  "qualifications-person",
  require("./components/recruiting/QualificationsPerson.vue").default,
);
Vue.component(
  "recruiting-chart-applicant-list",
  require("./components/recruiting/RecruitingChartApplicantList.vue").default,
);

//WorkInstances
Vue.component(
  "work-instances-steps",
  require("./components/work/workInstanceSteps").default,
);

//Workflow
Vue.component(
  "workflow-permissions",
  require("./components/workflow/editPermissions.vue").default,
);
Vue.component(
  "question-output-matrix",
  require("./components/workflow/questionOutputMatrix.vue").default,
);

//BaseChart
Vue.component(
  "table-factors-base-chart",
  require("./components/baseChart/table-factors").default,
);
//Evaluation
Vue.component(
  "evaluation-handle-chart",
  require("./components/EvaluationHandleChart.vue").default,
);
Vue.component(
  "evaluation-statuses-deadlines",
  require("./components/vueTable/evaluations/EvaluationStatusesDeadlines.vue")
    .default,
);
Vue.component(
  "evaluation-add-all-charts",
  require("./components/vueTable/evaluations/EvaluationAddAllCharts.vue")
    .default,
);
Vue.component(
  "evaluation-change-session",
  require("./components/vueTable/evaluations/EvaluationChangeSession.vue")
    .default,
);
Vue.component(
  "next-state-button",
  require("./components/vueTable/evaluations/NextStateButton.vue").default,
);
Vue.component(
  "people-filters",
  require("./components/vueTable/filters/PeopleFilters.vue").default,
);
Vue.component(
  "kpis-filters",
  require("./components/vueTable/filters/KpisFilters.vue").default,
);
Vue.component(
  "projects-filters",
  require("./components/vueTable/filters/ProjectsFilters.vue").default,
);
Vue.component(
  "pay-items-filters",
  require("./components/vueTable/filters/PayItemsFilters.vue").default,
);
Vue.component(
  "recruiting-applicants-filters",
  require("./components/vueTable/filters/RecruitingApplicantsFilters.vue").default,
);
Vue.component(
  "assettables-filters",
  require("./components/vueTable/filters/AssettablesFilters.vue").default,
);
Vue.component(
  "orgUnit-filters",
  require("./components/vueTable/filters/OrgUnitFilters.vue").default,
);
Vue.component(
  "roles-filters",
  require("./components/vueTable/filters/RolesFilters.vue").default,
);
Vue.component(
  "historical-filters",
  require("./components/vueTable/filters/HistoricalFilters.vue").default,
);
Vue.component(
  "hourly-filters",
  require("./components/vueTable/filters/HourlyFilters.vue").default,
);
Vue.component(
  "just-current-filters",
  require("./components/vueTable/filters/JustCurrentFilters.vue").default,
);
Vue.component(
  "merit-matrix-sessions-filters",
  require("./components/vueTable/filters/MeritMatrixSessionFilters.vue")
    .default,
);
Vue.component(
  "deadlines-filters",
  require("./components/vueTable/filters/DeadlinesFilters.vue").default,
);

//Questions Conf
Vue.component(
  "comment-evaluation-conf",
  require("./components/questions/config/CommentConf.vue").default,
);
Vue.component(
  "date-evaluation-conf",
  require("./components/questions/config/DateConf.vue").default,
);
Vue.component(
  "link-evaluation-conf",
  require("./components/questions/config/LinkConf.vue").default,
);
Vue.component(
  "ranking-evaluation-conf",
  require("./components/questions/config/RankingConf.vue").default,
);
Vue.component(
  "applicant-conf",
  require("./components/questions/config/ApplicantConf.vue").default,
);
Vue.component(
  "matrix-evaluation-conf",
  require("./components/questions/config/MatrixConf.vue").default,
);
Vue.component(
  "header-conf",
  require("./components/questions/config/HeaderConf.vue").default,
);
Vue.component(
  "level-conf",
  require("./components/questions/config/LevelConf.vue").default,
);
Vue.component(
  "p-and-p-conf",
  require("./components/questions/config/PnPConf.vue").default,
);
Vue.component(
  "learning-request-conf",
  require("./components/questions/config/LearningRequestConf.vue").default,
);
Vue.component(
  "static-text-conf",
  require("./components/questions/config/StaticTextConf.vue").default,
);
Vue.component(
  "targets-kpi-conf",
  require("./components/questions/config/TargetsConf.vue").default,
);
Vue.component(
  "course-satisfaction-conf",
  require("./components/questions/config/CourseSatisfactionConf.vue").default,
);
Vue.component(
  "behaviors-conf",
  require("./components/questions/config/BehaviorsConf.vue").default,
);
Vue.component(
  "assignment-conf",
  require("./components/questions/config/AssignmentConf.vue").default,
);
Vue.component(
  "projects-conf",
  require("./components/questions/config/ProjectConf.vue").default,
);
Vue.component(
  "goals-conf",
  require("./components/questions/config/GoalsConf.vue").default,
);
Vue.component(
  "summary-conf",
  require("./components/questions/config/SummaryConf.vue").default,
);
Vue.component(
  "skills-personal-conf",
  require("./components/questions/config/SkillsPersonalConf.vue").default,
);
Vue.component(
  "applicant-candidature-conf",
  require("./components/questions/config/ApplicantCandidatureConf").default,
);
Vue.component(
  "odem-conf",
  require("./components/questions/config/OdemConf").default,
);
Vue.component(
  "careers-conf",
  require("./components/questions/config/CareersConf").default,
);
Vue.component(
  "status-info-conf",
  require("./components/questions/config/StatusInfoConf").default,
);
Vue.component(
  "matrix-calculation-conf",
  require("./components/questions/config/MatrixCalculationConf.vue").default,
);
Vue.component(
  "development-proposals-conf",
  require("./components/questions/config/DevelopemetProposalsConf.vue").default,
);
Vue.component(
  "duties-task-evaluation-conf",
  require("./components/questions/config/DutiesTaskConf.vue").default,
);
Vue.component(
  "applicant-work-experience-conf",
  require("./components/questions/config/ApplicantWorkExperienceConf.vue")
    .default,
);
Vue.component(
  "applicant-known-languages-conf",
  require("./components/questions/config/ApplicantKnownLanguagesConf.vue")
    .default,
);
Vue.component(
  "global-rating-conf",
  require("./components/questions/config/GlobalRatingConf.vue").default,
);
Vue.component(
  "matrix-composable-conf",
  require("./components/questions/config/MatrixComposableConf.vue").default,
);
Vue.component(
  "applicant-educations-conf",
  require("./components/questions/config/ApplicantEducationsConf.vue").default,
);
Vue.component(
  "skill-matrix-review-conf",
  require("./components/questions/config/SkillMatrixReviewConf.vue").default,
);
Vue.component(
  "person-skills-review-conf",
  require("./components/questions/config/PersonSkillsReviewConf.vue").default,
);
Vue.component(
  "dynamic-future-levels",
  require("./components/questions/config/DynamicFutureLevelsConf.vue").default,
);
Vue.component(
  "revision-conf",
  require("./components/questions/config/RevisionConf.vue").default,
);
Vue.component(
  "on-boarding-conf",
  require("./components/questions/config/OnBoardingConf.vue").default,
);
Vue.component(
  "checklist-conf",
  require("./components/questions/config/ChecklistConf.vue").default,
);
Vue.component(
  "document-conf",
  require("./components/questions/config/DocumentConf.vue").default,
);

Vue.component(
  "multi-evaluators-conf",
  require("./components/questions/config/MultiEvaluatorsConf.vue").default,
);

Vue.component(
  "known-languages-conf",
  require("./components/questions/config/KnownLanguagesConf.vue").default,
);


//Question and graphs on Sheets

Vue.component(
  "matrix-question",
  require("./components/questions/sheet/MatrixQuestion.vue").default,
);
Vue.component(
  "levels-question",
  require("./components/questions/sheet/LevelsQuestion.vue").default,
);
Vue.component(
  "pnp-question",
  require("./components/questions/sheet/PnpQuestion.vue").default,
);
Vue.component(
  "horizontal-bar-pnp",
  require("./components/questions/sheet/HorizontaBar.vue").default,
);
Vue.component(
  "horizontal-bar-pnp-pdf",
  require("./components/questions/sheet/HorizontalBarPdf.vue").default,
);
Vue.component(
  "vertical-bar",
  require("./components/questions/sheet/VerticalBar.vue").default,
);
Vue.component(
  "radar-pnp",
  require("./components/questions/sheet/RadarPnp.vue").default,
);
Vue.component(
  "radar-pnp-pdf",
  require("./components/questions/sheet/RadarPnpPdf.vue").default,
);
Vue.component(
  "learning-request",
  require("./components/questions/sheet/LearningRequestQuestion.vue").default,
);
Vue.component(
  "target-kpi",
  require("./components/questions/sheet/TargetQuestion.vue").default,
);
Vue.component(
  "can-compile-target-kpi",
  require("./components/questions/sheet/CanCompileTargetQuestion.vue").default,
);
Vue.component(
  "course-satisfaction",
  require("./components/questions/sheet/CourseSatisfactionQuestion.vue")
    .default,
);
Vue.component(
  "behaviors-question",
  require("./components/questions/sheet/BehaviorsQuestion.vue").default,
);
Vue.component(
  "project-question",
  require("./components/questions/sheet/ProjectsQuestion.vue").default,
);
Vue.component(
  "goals-question",
  require("./components/questions/sheet/GoalsQuestion.vue").default,
);
Vue.component(
  "summary-pnp-question",
  require("./components/questions/sheet/SummaryPnpQuestion.vue").default,
);
Vue.component(
  "line-evaluation-chart",
  require("./components/questions/sheet/LineChart.vue").default,
);
Vue.component(
  "pie-evaluation-chart",
  require("./components/questions/sheet/PieChart.vue").default,
);
Vue.component(
  "skills-personal-question",
  require("./components/questions/sheet/SkillPersonalQuestion.vue").default,
);
Vue.component(
  "level-factors-proposals",
  require("./components/questions/sheet/LevelFactorsProposals.vue").default,
);
Vue.component(
  "matrix-calculation",
  require("./components/questions/sheet/MatrixCalculationQuestion.vue").default,
);
Vue.component(
  "development-proposals",
  require("./components/questions/sheet/DevelopmentProposalsQuestion.vue")
    .default,
);
Vue.component(
  "duties-task-evaluation",
  require("./components/questions/sheet/DutiesTaskQuestion.vue").default,
);
Vue.component(
  "applicant-work-experience",
  require("./components/questions/sheet/ApplicantWorkExperienceQuestion.vue")
    .default,
);
Vue.component(
  "applicant-known-languages",
  require("./components/questions/sheet/ApplicantKnownLanguagesQuestion.vue")
    .default,
);
Vue.component(
  "matrix-composable-question",
  require("./components/questions/sheet/MatrixComposableQuestion.vue").default,
);
Vue.component(
  "applicant-educations",
  require("./components/questions/sheet/ApplicantEducationsQuestion.vue")
    .default,
);

Vue.component(
  "change-person-role-on-icharts",
  require("./components/ChangePersonRoleOnICharts.vue").default,
);
//Courses
Vue.component(
  "clone-course",
  require("./components/courses/cloneCourse.vue").default,
);
Vue.component(
  "deadlines-course",
  require("./components/courses/DeadlinesCourse.vue").default,
);

//Compensations
Vue.component(
  "compensations-select-people",
  require("./components/CompensationsSelectPeople.vue").default,
);

Vue.component(
  "contractual-item-value",
  require("./components/compensation/ContractualItemValue.vue").default,
);

Vue.component(
  "role-horizon-temp-edit",
  require("./components/compensation/RoleHorizonTempEdit").default,
);

//KPI

Vue.component(
  "kpi-incentive-plan-summary",
  require("./components/kpis/KpiIncentivePlanSummary.vue").default,
);

Vue.component(
  "kpi-targets-docs",
  require("./components/kpis/KPITargetsDocs").default,
);

Vue.component(
  "kpis-targets-add-existing-on-chart",
  require("./components/kpis/AddExsistingKPIOnChart").default,
);
Vue.component("kpi-form", require("./components/kpis/KPIForm").default);

Vue.component(
  "kpi-segment-form",
  require("./components/kpis/KpiSegmentForm").default,
);

Vue.component(
  "kpis-add-basic",
  require("./components/kpis/AddKpiBasic").default,
);
Vue.component(
  "kpis-person-external-condition-form",
  require("./components/kpis/KPIPersonExternalConditionForm").default,
);

Vue.component("user", require("./components/UserSettings").default);

Vue.component(
  "document-template-signature-level-sub-form",
  require("./components/DocumentTemplateSignatureLevelSubForm.vue").default,
);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

function appDisabledWithoutPermission() {
  var hrButtonHidden = $(".hrtButtonHidden");
  if (
    hrButtonHidden !== undefined &&
    hrButtonHidden != null &&
    hrButtonHidden.length > 0
  ) {
    for (var i = 0; i < hrButtonHidden.length; i++) {
      var form = $(hrButtonHidden[i]).parents("form");
      form.each(function () {
        var inputs = $(this).find(":input");
        if (inputs !== undefined && inputs != null && inputs.length > 0) {
          for (var c = 0; c < inputs.length; c++) {
            var isNotDisabled = $(inputs[c]).attr("not-disabled-permission");
            if (!isNotDisabled) {
              $(inputs[c]).prop("disabled", true);
            }
          }
        }

        var multiselect = $(this).find(".multiselect");
        if (multiselect !== undefined && multiselect != null) {
          multiselect.addClass("multiselect--disabled");
        }
      });
    }
  }
}

const app = new Vue({
  el: "#app",
  methods: {
    questionPermission(can_write, enable) {
      if (can_write) {
        can_write = enable;
      }
      return can_write;
    },
    reloadWidget(widgetRef, url, params, filtersUrl) {
      console.log(url, params, filtersUrl);
      this.$refs.vue_popup.active = false;
      this.$refs[widgetRef].changeUrl(url + "?" + params);

      let filtersUrlWithParams = filtersUrl + "?" + params;
      $("#filters_" + widgetRef).attr(
        "onclick",
        "app.__vue__.$refs.vue_popup.toggle('','" + filtersUrlWithParams + "')",
      );
    },
    reloadGrupOfWidgets(widgetRefs, params) {
      for (var i = 0; i < widgetRefs.length; i++) {
        this.$refs[widgetRefs[i]["ref"]].changeUrl(
          widgetRefs[i]["url"] + "?" + params,
        );
      }
      this.$refs.vue_popup.active = false;
    },
    appendLoader() {
      if (this.$vs.loading == null || this.$vs.loading === undefined) {
        this.$vs.loading();
      }
    },
    removeLoader() {
      this.$vs.loading.close();
    },

    logout() {
      axios.post("/logout", {}).then(function (response) {
        location.href = response.data;
      });
    },
    handleRightScroll(element) {
      var leftAmount = element.scrollLeft();
      element.animate(
        {
          scrollLeft: (leftAmount += 300),
        },
        400,
      );
    },
    handleLeftScroll(element) {
      var leftAmount = element.scrollLeft();
      element.animate(
        {
          scrollLeft: (leftAmount -= 300),
        },
        400,
      );
    },
    actionBulkDelete(endPoint, items) {
      let item_ids = items.map(function (item) {
        return item.id;
      });
      if (items.length == 0) {
        Vue.swal.fire({
          title: "Selezionare un elemento",
        });
      } else {
        Vue.swal
          .fire({
            title: "Sicuro/a di voler procedere?",
            text: "L'operazione sarà irreversibile",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Conferma",
            cancelButtonText: "Annulla",
          })
          .then((result) => {
            if (result.value) {
              let deleteId = "";
              for (let i = 0; i < item_ids.length; i++) {
                deleteId += "id[]=" + item_ids[i] + "&";
              }
              deleteId = deleteId.substring(0, deleteId.length - 1);
              location.href = endPoint + "?" + deleteId;
            }
          });
      }
    },
    actionBulkArchive(endPoint, items) {
      let item_ids = items.map(function (item) {
        return item.id;
      });
      if (items.length == 0) {
        Vue.swal.fire({
          title: "Seleziona un elemento",
        });
      } else {
        Vue.swal
          .fire({
            title: "Sicuro/a di voler procedere?",
            text: "Sei sicuro/a di voler archiviare questi candidati?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Conferma",
            cancelButtonText: "Annulla",
          })
          .then((result) => {
            if (result.value) {
              let archiviedId = "";
              for (let i = 0; i < item_ids.length; i++) {
                archiviedId += "id[]=" + item_ids[i] + "&";
              }
              archiviedId = archiviedId.substring(0, archiviedId.length - 1);
              location.href = endPoint + "?" + archiviedId;
            }
          });
      }
    },
    applyFiltersOnWidget(widget) {
      console.log(widget);
      //let filters = // Get all input with class "."+widget+"_filter"
      //refs.graph_widget_1_1.fetchDatas(filters)
    },
    actionPut(txt, endPoint) {
      console.log(endPoint);
      Vue.swal
        .fire({
          title: "Sicuro/a di voler procedere?",
          text: txt,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Conferma",
          cancelButtonText: "Annulla",
        })
        .then((result) => {
          if (result.value) {
            axios
              .put(endPoint)
              .then((data) => {
                location.reload();
              })
              .catch((err) => {
                Vue.swal.fire("Ops...qualcosa è andato storto!");
              });
          }
        });
    },
    actionGet(endPoint) {
      Vue.swal
        .fire({
          title: "Sicuro/a di voler procedere?",
          text: "L'operazione sarà irreversibile",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Conferma",
          cancelButtonText: "Annulla",
        })
        .then((result) => {
          if (result.value) {
            axios
              .get(endPoint)
              .then((data) => {
                location.reload();
              })
              .catch((err) => {
                Vue.swal.fire("Ops...qualcosa è andato storto!");
              });
          }
        });
    },
    actionPost(endPoint, titleMessage = "Sicuro di voler procedere?", bodyMessage = "L'operazione sarà irreversibile") {
      Vue.swal
        .fire({
          title: titleMessage,
          text: bodyMessage,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Conferma",
          cancelButtonText: "Annulla",
        })
        .then((result) => {
          if (result.value) {
            this.$vs.loading();
            axios
              .post(endPoint)
              .then((data) => {
                this.$vs.loading.close();
                location.reload();
              })
              .catch((err) => {
                this.$vs.loading.close();
                Vue.swal.fire("Ops...qualcosa è andato storto!");
              });
          }
        });
    },
    actionDelete(endPoint) {
      if (endPoint == null || endPoint == "" || endPoint == undefined) {
        return;
      }

      Vue.swal
        .fire({
          title: "Sicuro/a di voler procedere?",
          text: "L'operazione sarà irreversibile",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Conferma",
          cancelButtonText: "Annulla",
        })
        .then((result) => {
          if (result.value) {
            axios
              .delete(endPoint)
              .then((data) => {
                location.reload();
              })
              .catch((err) => {
                console.log(err);
                Vue.swal.fire("Ops...qualcosa è andato storto!");
              });
          }
        }).catch((error) => {          
          if (error.response.status == 405) {
            Vue.swal.fire({
              title: error.response.data.advice.title,
              html: error.response.data.advice.html,
              icon: "error",
            });
          } else if (error.response.status == 403) {
            Vue.swal.fire({
              title: error.response.data.advice.title,
              html: error.response.data.advice.html,
              icon: "warning",
            });
          } else {
            location.reload();
          }
        });
    },
    passwordGenerate(endPoint, items) {
      let item_ids = items.map(function (item) {
        return item.id;
      });
      if (items.length == 0) {
        Vue.swal.fire({
          title: "Selezionare un elemento",
        });
      } else {
        Vue.swal
          .fire({
            title: "Sicuro/a di voler procedere?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Conferma",
            cancelButtonText: "Annulla",
          })
          .then((result) => {
            if (result.value) {
              let deleteId = "";
              for (let i = 0; i < item_ids.length; i++) {
                axios
                  .post("/update-password", { id: item_ids[i] })
                  .then((response) => {
                    //
                  });
              }
            }
          });
      }
    },
    removeParam(key) {
      var sourceURL = location.href;
      var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString =
          sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
      if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
            params_arr.splice(i, 1);
          }
        }
        rtn = rtn + "?" + params_arr.join("&");
      }
      return rtn;
    },
    addParam(key, value) {
      var currentUrl = this.removeParam(key);
      var devider = "?";
      if (currentUrl.indexOf("?") >= 0) devider = "&";
      return currentUrl + devider + key + "=" + value;
    },
    toggleSelectAllComepnsations(item) {
      if (item.is(":checked")) {
        $(".evaluation_" + item.data("evaluation_id")).attr("checked", true);
      } else {
        $(".evaluation_" + item.data("evaluation_id")).attr("checked", false);
      }
    },
    selectPeopleInSidebar(route, evaluationSession = null) {
      let items = [];
      if (evaluationSession != null) {
        console.log(evaluationSession);
        items = [{ id: evaluationSession }];
        app.$refs.compensations_select_people.toggle(
          "",
          route + "?qs=start",
          items,
        );
      } else {
        if (app.$refs.evaluation_sessions_vuetable.itemsSelected.length == 0) {
          Vue.swal.fire({
            title: "Selezionare una sessione di valutazione",
          });
        } else {
          items = app.$refs.evaluation_sessions_vuetable.itemsSelected;
          app.$refs.compensations_select_people.toggle(
            "",
            route + "?qs=start",
            items,
          );
        }
      }
    },
    filterFields(container, term) {
      //let itemContainer = container;
      for (let i = 0; i < container.find("label").length; i++) {
        let itemContainer = $(container.find("label")[i]);
        console.log(itemContainer.text());
        if (
          itemContainer.text().toLowerCase().indexOf(term.toLowerCase()) > -1
        ) {
          itemContainer.parent().removeClass("hidden");
        } else {
          itemContainer.parent().addClass("hidden");
        }
      }
    },
    proposalsChoosersFilterCallback(cc) {
      console.log("called!", cc);
    },
    disabledWithoutPermission() {
      appDisabledWithoutPermission();
    },
    setVueTableOptions(params) {
      axios
        .put("/set-vue-table-options", { params })
        .then((response) => { })
        .catch((error) => {
          console.log(error);
        });
    },
  },
});

$(document).ready(function () {
  $(".js-example-basic").select2();
  if ($("#select_preset").length > 0) {
    $("#select_preset").change(function () {
      let permissionsConfiguration = $("#select_preset option:selected").data(
        "configuration",
      );
      if (permissionsConfiguration !== undefined) {
        $(".custom_permissions").each((index, item) => {
          $(item).prop("checked", false);
        });

        permissionsConfiguration.forEach((element, index) => {
          $("#can_view_" + element.module_id).prop("checked", element.can_view);
          $("#can_edit_" + element.module_id).prop("checked", element.can_edit);

          //set organizationalUnits
          $(
            'input[name="organizationalUnits[' + element.module_id + '][]"]',
          ).each((index, item) => {
            if (jQuery.inArray(item.value, element.organizationalUnits) >= 0) {
              $(item).prop("checked", true);
            }
          });

          //set headquarters
          $('input[name="headquarters[' + element.module_id + '][]"]').each(
            (index, item) => {
              if (jQuery.inArray(item.value, element.headquarters) >= 0) {
                $(item).prop("checked", true);
              }
            },
          );
        });
      }

      //Customs permissions
      let permissionsConfigurationCustom = $(
        "#select_preset option:selected",
      ).data("custom_configuration");

      if (permissionsConfigurationCustom !== undefined) {
        permissionsConfigurationCustom.forEach((element) => {
          $("#" + element.replace(".", "-")).prop("checked", true);
        });
      }
    });
  }

  if ($("#select_preset_permission").length > 0) {
    $("#select_preset_permission").on("change", function (e) {
      //New permissions
      let permissions = $("#select_preset_permission option:selected").data(
        "preset-permission",
      );
      if (permissions !== undefined) {
        $('*[data-permission-checkbox="1"]').removeAttr("checked");

        let moduleVoiceId = Object.keys(permissions);
        if (moduleVoiceId != null) {
          for (var i = 0; i < moduleVoiceId.length; i++) {
            var slugsObj = permissions[moduleVoiceId[i]];
            if (
              slugsObj != null &&
              slugsObj["permission_action_slug"] !== undefined
            ) {
              var slugs = Object.keys(slugsObj["permission_action_slug"]);
              if (slugs) {
                slugs.forEach((slug) => {
                  e.preventDefault();
                  var el = $(
                    "#module_voice_" + moduleVoiceId[i] + "_slug_" + slug,
                  );
                  if (el.attr("checked")) {
                    el.removeAttr("checked");
                  } else {
                    el.attr("checked", "checked");
                  }
                  e.stopPropagation();
                });
              }
            }
          }
        }
      }
    });
  }

  appDisabledWithoutPermission();

  /*
   * Mounted delayed
   * */
  setTimeout(function () {
    let vue_ref_keys = Object.keys(app.$refs);
    vue_ref_keys.forEach(function (ref) {
      if (typeof app.$refs[ref].mountedDelayed === "function") {
        // safe to use the function
        app.$refs[ref].mountedDelayed();
      }
    });
  }, 2500);

  $("form").submit(function () {
    appendOverlay();
  });

  function appendOverlay() {
    // prevent send multiple submit on forms
  }

  // --------------------------------------
  // Shrink Sidebar Menu
  // --------------------------------------
  // if($(window).width() <= 1400) {
  // 	// $('aside').addClass('is--shrinked')
  // 	$('.page-wrapper').addClass('is--full-width');
  // }
  $(".shrink--aside").on("click", function () {
    $("aside").toggleClass("is--shrinked");
    $(".page-wrapper").toggleClass("is--full-width");
  });

  // --------------------------------------
  // Enable tooltips everywhere
  // --------------------------------------
  $('[data-toggle="tooltip"]').tooltip();

  // --------------------------------------
  // Shrinked toggle profile content block
  // --------------------------------------
  $(".shrinked--toggle").on("click", function () {
    if ($(this).hasClass("shrinked--toggle-inner-section")) {
      $(this).parent().parent().parent().toggleClass("minimized");
    }
    $(this).parent().parent().toggleClass("minimized");
  });

  // --------------------------------------
  // Toggle Sub Menu
  // --------------------------------------
  $(".navigation-elements-with-sub-menu").on("click", function (e) {
    e.preventDefault();
    $(this).parent().siblings().find("a").removeClass("is--open");
    $(this)
      .parent()
      .siblings()
      .find(".navigation-list")
      .removeClass("is--visible");
    var _this = this;

    setTimeout(function () {
      $(_this).toggleClass("is--open");
      $(_this).parent().find(".navigation-list").toggleClass("is--visible");
    }, 100);
    if ($("aside").hasClass("is--shrinked")) {
      $("aside").removeClass();
      $(".page-wrapper").removeClass("is--full-width");
    }
  });

  // --------------------------------------
  // Toggle User Notification
  // --------------------------------------
  // $('.user--notifications').on('click', function(e){
  // 	e.preventDefault()
  // 	console.log('clicked')
  // 	$('.notification--list').toggleClass('is--visible');
  // })

  // --------------------------------------
  // Toggle active class List view
  // --------------------------------------
  $(".single--list-view").on("click", function () {
    $(this).siblings().removeClass("single--list-view-active");
    $(this).addClass("single--list-view-active");
  });

  // --------------------------------------
  // Toggle show Actions buttons
  // --------------------------------------
  $(".dropdown--select").on("click", function (e) {
    e.preventDefault();
    $(this).parent().find(".dropdown--options").toggleClass("is--visible");
    e.stopPropagation();
    $("#app").on("click", function (e) {
      if ($(e.target).is(".dropdown--options") === false) {
        $(".dropdown--options").removeClass("is--visible");
      }
    });
  });

  // ----------------------------------------
  // Add attribute checked - Checkbox
  // ----------------------------------------
  $(".form-check label").on("click", function (e) {
    e.preventDefault();
    var el = $(this).parent().find("input");
    if (el.attr("checked")) {
      el.removeAttr("checked");
    } else {
      el.attr("checked", "checked");
    }
    e.stopPropagation();
  });

  // --------------------------------------
  // Tabs
  // --------------------------------------
  $(".tabs-component-tabs li a").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
  });

  $(".collapse-open").click();

  $(".profile-notification-button").click((evt) => {
    $(evt.target).parent().find(".bullet").hide();
    $.ajax({
      url: "/me/employee/mark-notifications-read",
    });
  });

  $("#header-employee i").on("click", function () {
    $("aside").toggleClass("is--shrinked");
  });

  $(".notification .fa-bell").on("click", function () {
    $(".notifications--list").addClass("visible");
  });
  $(".notifications--list .fa-times").on("click", function () {
    $(".notifications--list").removeClass("visible");
  });

  $(".block--profile-title .fa-exclamation-triangle").on("click", function () {
    $(".alert-notify").addClass("visible");
  });
  $(".alert-notify .fa-times").on("click", function () {
    $(".alert-notify").removeClass("visible");
  });
  $(document).on("change", ".checkboxSelectAllNoVue", function (e) {
    let dataClass = $(this).data("clan"); //all checkbox list of this family
    let valueCheckBoss = this.checked;

    $("." + dataClass).each(function () {
      $(this).prop("checked", valueCheckBoss);
    });
  });

  $(".progress-circle").each(function () {
    var value = $(this).attr("data-value");
    var left = $(this).find(".progress-left .progress-bar");
    var right = $(this).find(".progress-right .progress-bar");
    if (value > 0) {
      if (value <= 50) {
        right.css("transform", "rotate(" + percentageToDegrees(value) + "deg)");
      } else {
        right.css("transform", "rotate(180deg)");
        left.css(
          "transform",
          "rotate(" + percentageToDegrees(value - 50) + "deg)",
        );
      }
    }
  });

  function percentageToDegrees(percentage) {
    return (percentage / 100) * 360;
  }

  var teamOverview = document.getElementById("team-overview");
  if (teamOverview != null) {
    var ctx = teamOverview.getContext("2d");
    new Chart(ctx, {
      type: "bar",
      data: {
        labels: [
          "<  1",
          "1 - 2",
          "3 - 4",
          "5 - 9",
          "10 - 14",
          "15 - 19",
          "20 - 24",
          "25 - 29",
          "> - 29",
        ],
        datasets: [
          {
            label: "Employee",
            backgroundColor: "#caf270",
            data: [12, 59, 5, 56, 58, 12, 59, 87, 45],
          },
          {
            label: "Engineer",
            backgroundColor: "#45c490",
            data: [12, 59, 5, 56, 58, 12, 59, 85, 23],
          },
          {
            label: "Government",
            backgroundColor: "#008d93",
            data: [12, 59, 5, 56, 58, 12, 59, 65, 51],
          },
          {
            label: "Political parties",
            backgroundColor: "#2e5468",
            data: [12, 59, 5, 56, 58, 12, 59, 12, 74],
          },
        ],
      },
      options: {
        tooltips: {
          displayColors: true,
          callbacks: {
            mode: "x",
          },
        },
        scales: {
          xAxes: [
            {
              stacked: true,
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              stacked: true,
              ticks: {
                beginAtZero: true,
              },
              type: "linear",
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: true,
        legend: { position: "top" },
      },
    });
  }
});
import { Html5Qrcode } from 'html5-qrcode';
window.Html5Qrcode = Html5Qrcode;

import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import allLocales from '@fullcalendar/core/locales-all';
import interactionPlugin from '@fullcalendar/interaction';

window.FullCalendar = Calendar;
window.FullCalendarPlugins = { dayGridPlugin, timeGridPlugin, listPlugin, allLocales, interactionPlugin };
/* 
document
  .querySelector("[aria-controls='#grafico']")
  .addEventListener("click", () => console.log(22));
 */
window.addEventListener('show-notification', (event) => {
  Vue.$toast.open({
    message: event.detail.message,
    type: event.detail.type,
    position: 'bottom-right'
  });
});